export const ENDPOINTS = {
  AUTH: {
    LOGIN: '/user/login-admin',
    LOGOUT: '/user/logout',
    VERIFY_TOKEN: '/user/verify-token',
    REFRESH: '/refresh',
  },

  EXAM: {
    BASE: '/exam',
    SINGLE: (id) => `/exam/single/${id}`,
  },

  READING: {
    BASE: '/reading',
    QUESTION_SETS: (readingId, passage) => `/reading/${readingId}/${passage}/question-sets`,
    QUESTION_SET: (readingId, passage, qsId) => `/reading/${readingId}/${passage}/question-sets/${qsId}`,
    QUESTIONS: (readingId, passage, qsId) => `/reading/${readingId}/${passage}/question-sets/${qsId}/questions`,
    QUESTION: (readingId, passage, qsId, qId) => `/reading/${readingId}/${passage}/question-sets/${qsId}/questions/${qId}`,
    CREATE_QUESTION_SET: (readingId, passage) => `/reading/createQuestionSet/${readingId}/${passage}`,
    UPDATE_QUESTION_SET: (readingId, passage, qsId) => `/reading/updateQuestionSet/${readingId}/${passage}/${qsId}`,
    DELETE_QUESTION_SET: (readingId, passage, qsId) => `/reading/deleteQuestionSet/${readingId}/${passage}/${qsId}`,
    CREATE_QUESTION: (readingId, passage, qsId) => `/reading/createQuestion/${readingId}/${passage}/${qsId}`,
    UPDATE_QUESTION: (readingId, passage, qsId, qId) => `/reading/updateQuestion/${readingId}/${passage}/${qsId}/${qId}`,
    DELETE_QUESTION: (readingId, passage, qId) => `/reading/deleteQuestion/${readingId}/${passage}/${qId}`,
  },

  LISTENING: {
    BASE: '/listening',
    QUESTION_SETS: (listeningId, part) => `/listening/${listeningId}/${part}/question-sets`,
    QUESTION_SET: (listeningId, part, qsId) => `/listening/${listeningId}/${part}/question-sets/${qsId}`,
    QUESTIONS: (listeningId, part, qsId) => `/listening/${listeningId}/${part}/question-sets/${qsId}/questions`,
    QUESTION: (listeningId, part, qsId, qId) => `/listening/${listeningId}/${part}/question-sets/${qsId}/questions/${qId}`,
    CREATE_QUESTION_SET: (listeningId, part) => `/listening/createQuestionSet/${listeningId}/${part}`,
    UPDATE_QUESTION_SET: (listeningId, part, qsId) => `/listening/updateQuestionSet/${listeningId}/${part}/${qsId}`,
    DELETE_QUESTION_SET: (listeningId, part, qsId) => `/listening/deleteQuestionSet/${listeningId}/${part}/${qsId}`,
    CREATE_QUESTION: (listeningId, part, qsId) => `/listening/createQuestion/${listeningId}/${part}/${qsId}`,
    UPDATE_QUESTION: (listeningId, part, qsId, qId) => `/listening/updateQuestion/${listeningId}/${part}/${qsId}/${qId}`,
    DELETE_QUESTION: (listeningId, part, qId) => `/listening/${listeningId}/${part}/deleteQuestion/${qId}`,
  },

  WRITING: {
    BASE: '/writing',
  },

  SPEAKING: {
    BASE: '/speaking',
    RESULTS_BY_REGISTER: (registerId) => `/speaking/getSpeakingResultsByRegisterId/${registerId}`,
    AVAILABLE_SCHEDULE: (examId) => `/speaking/getAvailableSpeakingSchedule/${examId}`,
    AVAILABLE_ONLY_SCHEDULE: '/speaking/getAvailableOnlySpeakingSchedule',
    EXAM_HISTORY: '/speaking/getExamHistoryList',
    RESERVE_SCHEDULE: '/speaking/reserveSpeakingSchedule',
    CREATE_MEETS: (examId) => `/speaking/createSpeakingMeets/${examId}`,
    SEND_RESULT_EMAIL: (toEmail, uprId) => `/speaking/sendResultEmailToSomeone/${toEmail}/${uprId}`,
  },

  BLOG: {
    BASE: '/blog',
    GET_ALL: '/blog/getBlogs',
    GET_FOR_HOME: '/blog/getBlogsForHome',
    CREATE: '/blog/createBlogPost',
    UPDATE: (id) => `/blog/updateBlog/${id}`,
    DELETE: (id) => `/blog/deleteBlog/${id}`,
  },

  INSTRUCTOR: {
    BASE: '/instructors',
  },

  ADMIN: {
    BASE: '/admin',
    USERS: '/admin/users',
    USER: (id) => `/admin/users/${id}`,
    REGISTRATIONS: '/admin/registrations',
    REGISTRATION: (id) => `/admin/registrations/${id}`,
    BULK_DELETE_REGISTRATIONS: '/admin/registrations/bulk-delete',
    SCORES: '/admin/scores',
    SCORE: (id) => `/admin/scores/${id}`,
    SCORE_BY_REGISTRATION: (regId) => `/admin/scores/registration/${regId}`,
    EXAMS: '/admin/exams',
    EXAM: (id) => `/admin/exams/${id}`,
    EXAM_CALCULATE_SCORES: (id) => `/admin/exams/${id}/calculate-scores`,
    SPEAKING_SESSIONS: '/admin/speaking-sessions',
    SPEAKING_SESSION: (id) => `/admin/speaking-sessions/${id}`,
    REFERRALS: '/admin/referrals',
    REFERRAL: (id) => `/admin/referrals/${id}`,
    PRODUCT_SESSIONS: '/admin/product-sessions',
    PRODUCT_SESSION: (id) => `/admin/product-sessions/${id}`,
    INVOICES: '/admin/invoices',
    INVOICE: (id) => `/admin/invoices/${id}`,
    INVOICE_STATS: '/admin/invoices/stats',
  },

  USER_SESSIONS: {
    ALL: '/user-sessions/admin/all',
    BY_USER: (userId) => `/user-sessions/admin/user/${userId}`,
    TERMINATE: (sessionId) => `/user-sessions/admin/${sessionId}`,
    TERMINATE_ALL_USER: (userId) => `/user-sessions/admin/user/${userId}/all`,
    VIOLATIONS: '/user-sessions/admin/violations',
    VIOLATIONS_RECENT: '/user-sessions/admin/violations/recent',
    VIOLATIONS_BY_USER: (userId) => `/user-sessions/admin/violations/user/${userId}`,
  },

  STATISTICS: {
    DASHBOARD: '/statistics/dashboard',
    USERS: '/statistics/users',
    REGISTRATIONS: '/statistics/registrations',
    REVENUE: '/statistics/revenue',
    EXAMS: '/statistics/exams',
    EXAM: (id) => `/statistics/exams/${id}`,
    SPEAKING: '/statistics/speaking',
    SCORES: '/statistics/scores',
    REFERRALS: '/statistics/referrals',
    EXAM_REGISTRATIONS: (examId) => `/statistics/exam-registrations/${examId}`,
  },

  ANSWERS: {
    READING: '/readingUserAnswers',
    READING_BY_ID: (id) => `/readingUserAnswers/${id}`,
    LISTENING: '/listeningUserAnswers',
    LISTENING_BY_ID: (id) => `/listeningUserAnswers/${id}`,
    WRITING: '/writingUserAnswers',
    WRITING_BY_ID: (id) => `/writingUserAnswers/${id}`,
    WRITING_BY_UPR: (uprId) => `/writingUserAnswers/getByUprId/${uprId}`,
    WRITING_BULK_UPDATE: '/writingUserAnswers/bulkUpdate',
  },

  FEEDBACK: {
    BASE: '/feedback',
    BY_ID: (id) => `/feedback/${id}`,
    BY_EXAM: (examId) => `/feedback/exam/${examId}`,
  },

  // Partner Member Management
  PARTNER_MEMBERS: {
    BASE: '/partner-members',
    MY_PARTNERS: '/partner-members/my-partners',
    ROLES: '/partner-members/roles',
    CHECK_ACCESS: (partnerId) => `/partner-members/check-access/${partnerId}`,
    BY_PARTNER: (partnerId) => `/partner-members/partner/${partnerId}`,
    PARTNER_STATS: (partnerId) => `/partner-members/partner/${partnerId}/stats`,
    BY_ID: (membershipId) => `/partner-members/${membershipId}`,
    UPDATE_ROLE: (membershipId) => `/partner-members/${membershipId}/role`,
    LEAVE: (partnerId) => `/partner-members/leave/${partnerId}`,
    TRANSFER_OWNERSHIP: '/partner-members/transfer-ownership',
  },

  // Partner Admin (Scoped Access)
  PARTNER_ADMIN: {
    CONTEXT: '/partner-admin/context',
    PARTNERS: '/partner-admin/partners',
    STATISTICS: '/partner-admin/statistics',
    STUDENTS: '/partner-admin/students',
    STUDENT: (attributionId) => `/partner-admin/students/${attributionId}`,
    CLASSIFY_STUDENT: (attributionId) => `/partner-admin/students/${attributionId}/classify`,
    REGISTRATIONS: '/partner-admin/registrations',
    INVOICES: '/partner-admin/invoices',
    SCORES: '/partner-admin/scores',
    SCORE: (id) => `/partner-admin/scores/${id}`,
    EXAMS: '/partner-admin/exams',
    READING_ANSWERS: '/partner-admin/reading-answers',
    LISTENING_ANSWERS: '/partner-admin/listening-answers',
    WRITING_ANSWERS: '/partner-admin/writing-answers',
    WRITING_ANSWER: (id) => `/partner-admin/writing-answers/${id}`,
  },

  // Partner CRUD (existing, for reference)
  PARTNER: {
    BASE: '/partner',
    BY_ID: (id) => `/partner/${id}`,
    ACTIVE: '/partner/active',
  },
};
